// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + (chunkId === 1888 ? "Auth" : chunkId) + "." + {"1055":"ebbbe721","1888":"5f9698cf","6928":"b9073eaa","7815":"14148c59"}[chunkId] + ".chunk.css";
};